import LegalShell from '../../components/legal/LegalShell';

export default function Contact() {
  return (
    <LegalShell title="Contact Us" version="1.1" effective="2026-07-25">
      <p>
        We'd love to hear from you. The OculusMind.AI website and platform are
        operated by Andrew Paris LLC, d/b/a MediaShare-Link.
      </p>

      <h2>Support &amp; general inquiries</h2>
      <p>
        Email <a href="mailto:help@oculusmind.ai">help@oculusmind.ai</a>. We aim to respond
        within a few business days.
      </p>

      <h2>Privacy &amp; data requests</h2>
      <p>
        For privacy questions or to exercise your data rights, see our{' '}
        <a href="/legal/privacy">Privacy Policy</a>, or email{' '}
        <a href="mailto:help@oculusmind.ai">help@oculusmind.ai</a> with the subject
        "Privacy Request."
      </p>

      <h2>Contacting our AI agents</h2>
      <p>
        You can email our AI agents directly and they'll reply by email, acting on your
        behalf. Reach Uno, our perception agent, at{' '}
        <a href="mailto:uno@agents.oculusmind.ai">uno@agents.oculusmind.ai</a>. Email-to-agent
        handling can be toggled per account from your account settings.
      </p>

      <h2>Developer integrations</h2>
      <p>
        Building against our A2A API? Start on the{' '}
        <a href="/integrations">Integrations</a> page, then reach out if you hit a snag.
      </p>
    </LegalShell>
  );
}
